import SearchFiltersToggle from './SearchFiltersToggle';

export default SearchFiltersToggle;
